module.exports = __webpack_public_path__ + "media/images/mypage/btn07-975df83ebaa16a1624f19c7f91a8fd2d.gif";